var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFastfoodIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.613 11.25a.742.742 0 0 1-.582-.253.653.653 0 0 1-.168-.572c.237-1.238.9-2.16 1.987-2.766a7.194 7.194 0 0 1 3.562-.909c1.288 0 2.475.303 3.563.91 1.088.606 1.75 1.527 1.988 2.765a.653.653 0 0 1-.17.572.742.742 0 0 1-.58.253h-9.6Zm11.924 6v-6c0-1.438-.44-2.66-1.321-3.666-.882-1.006-2.122-1.709-3.722-2.109L8.4 4.594a.747.747 0 0 1 .178-.59.694.694 0 0 1 .553-.254h2.906V1.5c0-.212.072-.39.216-.534a.726.726 0 0 1 .534-.216c.213 0 .391.072.535.216a.726.726 0 0 1 .216.534v2.25h2.924c.226 0 .413.081.563.244.15.162.213.356.188.581L16.05 16.163c-.038.3-.172.556-.403.768a1.19 1.19 0 0 1-.835.319h-1.274Zm-12.037-3a.726.726 0 0 1-.534-.216.726.726 0 0 1-.216-.534c0-.213.072-.39.216-.534a.726.726 0 0 1 .534-.216h9.75c.213 0 .39.072.534.216A.726.726 0 0 1 12 13.5c0 .213-.072.39-.216.534a.726.726 0 0 1-.534.216H1.5Zm0 3a.726.726 0 0 1-.534-.216.726.726 0 0 1-.216-.534c0-.212.072-.39.216-.534a.726.726 0 0 1 .534-.216h9.75c.213 0 .39.072.534.216A.726.726 0 0 1 12 16.5c0 .212-.072.39-.216.534a.726.726 0 0 1-.534.216H1.5Z",
    fill: "#585C60"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastfoodIcon);
export default __webpack_public_path__ + "static/media/fastfood-icon.975ddb964ef4f3aa7df6b800d2705491.svg";
export { ForwardRef as ReactComponent };